import React from 'react';
import * as _ from 'lodash';

/**
 * 入退場QRコード発行 table
 * @param closed {boolean} 開閉状態
 * @param parterCompany {object}
 * @param selectedGroup {boolean} グループ単位での選択済みフラグ
 * @param isSelected {func} 1行ごとの選択済み判定
 * @param callbacks {object}
 */
export const EnterNameplatesContents = ({
  closed,
  parterCompany,
  selectedGroup,
  isSelected,
  callbacks,
}) => (
  <tbody className={closed ? 'table__group' : 'table__group show'}>
    <tr className='table-section-header'>
      <td className='entrance-exit-table entrance-exit-table--btn-group'>
        <div className='entrance-exit-table__icon'>
          <button
            className='btn-icon--sm'
            onClick={() =>
              callbacks.toggleGroup(!closed, parterCompany.partner_company_id)
            }
          >
            <i
              className={closed ? 'i-warrow-bottom i-2x' : 'i-warrow-top i-2x'}
            />
          </button>
        </div>
      </td>
      <td className='entrance-exit-table entrance-exit-table--btn-check'>
        <div className='entrance-exit-table__icon'>
          <div className='btn-checkbox'>
            <label
              htmlFor={`btn-checkbox-group-${
                parterCompany.partner_company_id
              }-all`}
            >
              <input
                id={`btn-checkbox-group-${
                  parterCompany.partner_company_id
                }-all`}
                className=''
                type='checkbox'
                checked={selectedGroup || false}
                onChange={() =>
                  callbacks.selectedGroup(
                    !selectedGroup,
                    parterCompany.partner_company_id
                  )
                }
              />
              <i className='i-square i-3x' />
            </label>
          </div>
        </div>
      </td>
      <td colSpan='7'>
        <div className='table-section-header__title'>{parterCompany.name}</div>
      </td>
    </tr>
    {_.map(parterCompany.worker, (worker, index) => (
      <Worker
        key={index}
        partnerCompanyId={parterCompany.partner_company_id}
        data={worker}
        selected={isSelected(parterCompany.partner_company_id, worker.user_id)}
        selectedRow={callbacks.selectedRow}
      />
    ))}
    <tr
      className='see-more'
      style={
        closed || parterCompany.workerLoaded
          ? { display: 'none' }
          : { display: 'table-row' }
      }
    >
      <td colSpan='15'>
        <button
          className='see-more__button'
          onClick={() => callbacks.seeMore(parterCompany.partner_company_id)}
        >
          さらに表示する
        </button>
      </td>
    </tr>
  </tbody>
);

/**
 * 入退場実績 子要素
 * @param data {object}
 * @param partnerCompanyId {int} 親のID
 * @param selected {boolean} 選択済みフラグ
 * @param selectedRow {func} クリックイベント
 */
const Worker = ({ data, partnerCompanyId, selected, selectedRow }) => (
  <tr className='table__item editable table__item--gate-schedule-table'>
    <td className='entrance-exit-table entrance-exit-table--id' />
    <td className='entrance-exit-table entrance-exit-table--btn-group'>
      <div className='btn-checkbox'>
        <label htmlFor={`btn-checkbox-group-${data.user_id}`}>
          <input
            id={`btn-checkbox-group-${data.user_id}`}
            className='sys-btn-checkbox'
            type='checkbox'
            value={data.user_id}
            checked={selected}
            onChange={e => selectedRow(e, partnerCompanyId, !selected)}
          />
          <i className='i-square i-3x' />
        </label>
      </div>
    </td>
    <td className='entrance-exit-table conf-font-size'>
      <div className='entrance-exit-table__txt--6'>{data.user_id}</div>
    </td>
    <td className='entrance-exit-table entrance-exit-table--value'>
      <div className='entrance-exit-table__txt--6'>{data.name}</div>
    </td>
    <td className='entrance-exit-table conf-font-size'>
      <div className='entrance-exit-table__txt--10'>{data.kana}</div>
    </td>
    <td className='entrance-exit-table conf-font-size'>
      <div className='entrance-exit-table__txt--4'>YYYY/MM/DD</div>
    </td>
    <td className='entrance-exit-table entrance-exit-table--value conf-font-size'>
      <div className='entrance-exit-table__txt--4'>YYYY/MM/DD</div>
    </td>
    <td className='entrance-exit-table'>
      <div className='box-info--long'>CCUS連携済</div>
    </td>
    <td />
  </tr>
);



// WEBPACK FOOTER //
// ./src/components/tables/EnterNameplates.jsx